import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import Translate from 'react-translate-component';

class ExceededWorkingHoursModal extends React.Component {

  static propTypes = {
    callback: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      open: true
    };
  }

  componentWillMount = () => {
    this.disableScroll();
  }

  componentWillUnmount = () => {
    this.enableScroll();
  }

  preventDefault = (e) => {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  }

  disableScroll = () => {
    window.onwheel = this.preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
    window.ontouchmove = this.preventDefault; // mobile
  }

  enableScroll = () => {
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
  }

  reject = () => {
    this.props.callback(false);
  }

  render = () => {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.open}
        onRequestClose={this.reject}>
        <div className='modal-content confirm-modal'>
          <button className='close' onClick={this.reject}></button>
          <h2><Translate content='EXCEEDING_WORKING_HOURS_TITLE' /></h2>
          <Translate content='EXCEEDING_WORKING_HOURS_BODY' className='pre-wrap' />
          <div className="btn-wrapper">
            <button
              key='reject'
              className='btn'
              onClick={this.reject} {...this.state.rejectButtonProps}
            >
              <Translate content='CLOSE' />
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ExceededWorkingHoursModal;



/** WEBPACK FOOTER **
 ** ./src/components/exceeded-working-hours-modal/exceeded-working-hours-modal.js
 **/